import { gql } from 'react-apollo';

export const updateChurchGroup = gql`
  mutation updateChurchGroup($input: UpdateChurchGroupInput!) {
    updateChurchGroup(input: $input) {
      church_group {
        id
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/groups/mutations/updateChurchGroup.js